<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <NewsForm :baseNews="news" :baseName="name" :loading="loading" @submit-requested="submitRequested"></NewsForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import NewsForm from './NewsForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                news: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { NewsForm },
        computed:
        {
            ...mapState('news', ['getNewsByIdOutput']),
        },
        methods: {
            ...mapActions('news', ['getNewsById']),
            ...mapActions('news', ['putNews']),
            submitRequested(news) {
                this.putNews(news);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "News"});
            }
            else {
                this.getNewsById(this.$route.query.id);
            }
        },
        watch:
        {
            getNewsByIdOutput: function (output) {
                if (!output) {
                    router.push({name: "News"});
                }
                else {
                    this.news = output;
                    this.loading = false;
                }
            }
        }
    }
</script>